import { BillingRedirectPage } from '@features/billing/components/BillingRedirectPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/billing')({ component: BillingRedirectPage });
